export interface Testimonial {
  id: string;
  name: string;
  role: string;
  quote: string;
  childAge?: string;
  isFormerAthlete?: boolean;
}

export const testimonials: Testimonial[] = [
  {
    id: "1",
    name: "Marco B.",
    role: "Papà di Lorenzo, 8 anni",
    quote: "Lorenzo era un bambino molto timido. Dopo un anno di Taekwondo ha trovato sicurezza e amici. I maestri sanno come tirare fuori il meglio dai bambini senza forzarli.",
    childAge: "8 anni"
  },
  {
    id: "2",
    name: "Giulia R.",
    role: "Mamma di Sofia, 10 anni",
    quote: "Sofia ha migliorato tantissimo la concentrazione a scuola. E la cosa più bella è che non vede l'ora che arrivi il giorno dell'allenamento.",
    childAge: "10 anni"
  },
  {
    id: "3",
    name: "Fabio L.",
    role: "Ex atleta dell'Academy, papà di Chiara, 12 anni",
    quote: "Ho praticato qui da ragazzo e oggi ci ho portato mia figlia. Il metodo è rimasto lo stesso: rispetto, disciplina, crescita. Sapevo che era il posto giusto.",
    childAge: "12 anni",
    isFormerAthlete: true
  },
  {
    id: "4",
    name: "Francesca T.",
    role: "Mamma di Andrea, 12 anni",
    quote: "Andrea attraversava un momento difficile, faticava ad ascoltare. Il Taekwondo gli ha dato una struttura che cercava. I miglioramenti sono stati evidenti anche a scuola.",
    childAge: "12 anni"
  },
  {
    id: "5",
    name: "Luca P.",
    role: "Ex atleta dell'Academy, papà di Emma, 9 anni",
    quote: "Sono tornato in questa palestra dopo 15 anni. Vedere mia figlia imparare gli stessi valori che ho appreso io è un'emozione indescrivibile. La qualità è rimasta altissima.",
    childAge: "9 anni",
    isFormerAthlete: true
  },
  {
    id: "6",
    name: "Chiara N.",
    role: "Mamma di Luca e Sara, 7 e 11 anni",
    quote: "Li ho iscritti insieme pensando fosse pratico. Si è rivelata la scelta migliore: si supportano a vicenda e hanno imparato cosa significa impegnarsi per un obiettivo.",
    childAge: "7 e 11 anni"
  }
];
